import React, { useState, useEffect } from 'react';

function TextInput({ question, value = '', onChange }) {
  const [text, setText] = useState(value);

  // Update local state when value prop changes (new question)
  useEffect(() => {
    setText(value || '');
  }, [value, question.id]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setText(newValue);
    onChange(newValue);
  };

  return (
    <div className="text-input">
      <h3>{question.text}</h3>
      {question.description && <p className="question-description">{question.description}</p>}
      
      <textarea
        value={text}
        onChange={handleChange}
        placeholder={question.placeholder || 'Enter your response...'}
        className="text-input-field"
        rows={4}
        onClick={(e) => e.stopPropagation()}
        onFocus={(e) => e.stopPropagation()}
      />
      
      <div className="character-count">
        {text.length} characters
      </div>
    </div>
  );
}

export default TextInput;